module.exports = __webpack_public_path__ + "img/3.7d9756d5.jpg";